export default "__VITE_ASSET__BmZwdO4y__"